export function desactivarControlesActivos(map) {
  map.getControls().forEach((ctrl) => {
    if (ctrl.active) {
      ctrl.desactivar();
    }
  });
}
